/* BottomPanel.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Inline, xcss } from '@atlaskit/primitives';
import Pressable from '@atlaskit/primitives/pressable';
import React from 'react';
const _11 = "@media (hover:hover){._1rjn1eg3:hover{background-color:var(--ds-background-neutral-subtle-hovered)}._13khfqd3:active{background-color:var(--ds-background-neutral-subtle-pressed)}}";
const _10 = "._1di6fqd3:active{background-color:var(--ds-background-neutral-subtle-pressed)}";
const _9 = "._19itglyw{border:none}";
const _8 = "._80omtlke{cursor:pointer}";
const _7 = "._1bsb1osq{width:100%}";
const _6 = "._2rko1sit{border-radius:var(--ds-border-radius,3px)}";
const _5 = "._vwz41k92{line-height:1.25rem}";
const _4 = "._1wyb1j6v{font-size:1rem}";
const _3 = "._4t3igosd{height:var(--ds-space-500)}";
const _2 = "._syaz1blv{color:var(--ds-text)}";
const _ = "._bfhkuzmt{background-color:var(--ds-background-neutral-subtle)}";
const bottomPanelStyles = xcss({
  flex: 0,
  padding: 'space.200',
  borderTopColor: 'color.border',
  borderTopWidth: 'border.width',
  borderTopStyle: 'solid',
  boxShadow: 'elevation.shadow.overflow'
});

// Using styled button instead of Pressable so we can use hover media query
const ClearAllButton = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "button",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_bfhkuzmt _syaz1blv _4t3igosd _1wyb1j6v _vwz41k92 _2rko1sit _1bsb1osq _80omtlke _19itglyw _1di6fqd3 _1rjn1eg3 _13khfqd3", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  ClearAllButton.displayName = 'ClearAllButton';
}
const applyButtonStyles = xcss({
  backgroundColor: 'color.background.brand.bold',
  color: 'color.text.inverse',
  height: 'size.400',
  fontSize: '1rem',
  lineHeight: '1.25rem',
  borderRadius: 'border.radius',
  width: '100%',
  ':hover': {
    backgroundColor: 'color.background.brand.bold.hovered'
  },
  ':active': {
    backgroundColor: 'color.background.brand.bold.pressed'
  }
});
export const BottomPanel = _ref2 => {
  let {
    onApplyFilters,
    onClearAllFilters
  } = _ref2;
  return /*#__PURE__*/React.createElement(Inline, {
    spread: "space-between",
    xcss: bottomPanelStyles,
    space: "space.200"
  }, /*#__PURE__*/React.createElement(ClearAllButton, {
    onClick: onClearAllFilters
  }, "Clear all"), /*#__PURE__*/React.createElement(Pressable, {
    onClick: onApplyFilters,
    xcss: applyButtonStyles
  }, "Apply"));
};